import { Button } from '@unmind/design-system-components-web';
import { Namespace } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Body, CTAContainer, Heading, PromptContainer } from './styles';

interface Props {
  password?: string | null;
  externalRef?: string;
}

export const PromptCard = ({ externalRef, password }: Props) => {
  const { t: translate } = useTranslation<Namespace<'talk'>>('talk');

  if (!externalRef || !password) {
    return <></>;
  }

  // The design system is rendering an unexpected `/` at the start of `to`
  // For time, we're using `as` to render a link and a const for the `href` to avoid TypeScript warnings
  const anchorProps = {
    href: `${
      process.env.REACT_APP_UNMIND_MEET_URL
    }/lobby/m/${externalRef}/${password}?returnTo=${encodeURIComponent(
      window.location.href,
    )}`,
  };

  return (
    <PromptContainer>
      <Heading>{translate('outcome_measures.prompt.title')}</Heading>
      <Body>{translate('outcome_measures.prompt.body')}</Body>
      <CTAContainer>
        <Button
          as="a"
          {...anchorProps}
          variant="secondary"
          label={translate('outcome_measures.prompt.cta_button.label')}
        />
      </CTAContainer>
    </PromptContainer>
  );
};
